import { getSiteIdFromHost } from "@/sites/config"
import type { UseWidgetRegistrationProps, UseWidgetRegistrationResult } from "@/types/types"
import { useEffect, useMemo, useState } from "react"

export const useWidgetRegistration = ({
  items = [],
  componentId,
}: UseWidgetRegistrationProps): UseWidgetRegistrationResult => {
  const [siteId, setSiteId] = useState<string | null>(null)

  const validItems = useMemo(() => {
    return items.filter(item => {
      const hasBaseData =
        item.image &&
        (typeof item.image === "string" ? item.image.trim() : true) &&
        item.title &&
        item.title.trim() &&
        item.description &&
        item.description.trim() &&
        item.buttonText &&
        item.buttonText.trim() &&
        item.buttonType

      const hasButtonHandler =
        item.buttonType === "onClick" ? item.buttonOnClick?.trim() || item.hasEmailInput : true

      return hasBaseData && hasButtonHandler
    })
  }, [items])

  const hasValidItems = validItems.length > 0

  const id = useMemo(
    () => componentId || `widget-registration-${Math.random().toString(36).substr(2, 9)}`,
    [componentId],
  )

  useEffect(() => {
    if (typeof window !== "undefined") {
      const host = window.location.host
      const _siteId = getSiteIdFromHost(host)
      setSiteId(_siteId)
    }
  }, [])

  return {
    validItems,
    hasValidItems,
    id,
    siteId,
  }
}
